import React from "react";
import { EXPLAINER_BOXES } from "../data/mock";

function highlightAbba(text) {
  const parts = text.split(/(Abba|Life With Abba)/g);
  return parts.map((p, i) =>
    p === "Abba" || p === "Life With Abba" ? (
      <strong key={i} className="text-[#68c2d5]">
        {p}
      </strong>
    ) : (
      <React.Fragment key={i}>{p}</React.Fragment>
    )
  );
}

export default function Explainer() {
  return (
    <section className="border-t border-gray-100 py-16 md:py-20">
      <div className="max-w-4xl mx-auto px-5 text-center">
        <p className="font-serif-display text-[#68c2d5] text-[18px]">
          Share Your <strong className="font-bold">#LifeWithAbba.</strong>
        </p>
        <p className="font-serif-body text-[#444] text-[15px] md:text-[17px] mt-4 leading-relaxed">
          {highlightAbba(
            "Abba, your Heavenly Father, wants a closer, more social relationship with you."
          )}
          <br className="hidden md:block" />
          {highlightAbba(
            " Share with Him those casual, playful, and even serious moments of your everyday life, using the Life With Abba!"
          )}
        </p>
      </div>

      <div className="max-w-[1000px] mx-auto px-5 mt-12 grid grid-cols-1 md:grid-cols-3 gap-y-10 md:gap-x-[60px]">
        {EXPLAINER_BOXES.map((box) => (
          <div
            key={box.title}
            className="relative border border-[#d7e6ea] rounded-[10px] bg-transparent px-2 pt-9 pb-8 text-center"
          >
            <p className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white px-[15px] font-serif-body text-[#68c2d5] text-[18px] font-bold whitespace-nowrap">
              {box.title}
            </p>
            <p className="font-serif-body text-[#555] text-[14px] leading-[2.0] px-[5%]">
              {highlightAbba(box.body)}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
